import { render, staticRenderFns } from "./ClicCopilot.vue?vue&type=template&id=b348c73c&"
import script from "./ClicCopilot.vue?vue&type=script&lang=js&"
export * from "./ClicCopilot.vue?vue&type=script&lang=js&"
import style0 from "./ClicCopilot.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports